export const reportTypes = {
  CATEGORY: "category",
  LOADING: "loading",
  UPLOADER: "uploader",
  VACANCY: "vacancy",
};
